import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LoggerService } from 'src/app/telemetry/logger.service';
import { DeleteSyncDataByLegacyIdOperation } from '../../../driver-data/operations/sync/delete-sync-data-by-legacy-id-operation';

/**
 * Command used to delete all of the sync data attached to a dispatched service from the local device.
 */
@Injectable({
	providedIn: 'root'
})
export class DeleteAllSyncDataForDispatchedServiceCommandService {

	/**
	 * @constructor
	 * @param deleteSyncDataByLegacyIdOperation The operation used for deleting sync data by service legacy ID.
	 * @param logger The logging service.
	 */
	constructor(
		private readonly deleteSyncDataByLegacyIdOperation: DeleteSyncDataByLegacyIdOperation,
		private readonly logger: LoggerService
	) { }

	/**
	 * Deletes all sync records for a dispatched service from the local device.
	 * @param legacyId The service identifier for the sync data records to delete.
	 */
	public DeleteAllSyncDispatchedRecordsForAService$(legacyId: number): Observable<void> {
		return this.deleteSyncDataByLegacyIdOperation.Execute$(legacyId).pipe(
			tap({
				error: (error: any) => {
					this.logger.TrackError("Error occurred while deleting dispatched service sync data:", error);
				}
			})
		);
	}
}
